import { Model } from '@vuex-orm/core'
import User from '@/store/models/User'
import VideoRoomMaster from '@/store/models/VideoRoomMaster'
import moment from 'moment'

export default class VideoRoom extends Model {
  static entity = 'videoRooms'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      roomId: this.attr(null),
      roomOwnerId: this.attr(null),
      roomPassword: this.attr(null),
      videoRoomMasterId: this.attr(null),
      meetingTitle: this.string(''),
      meetingDescription: this.string(''),
      startAt: this.attr(null),
      endAt: this.attr(null),
      userIds: this.attr([]),
      temporaryGuestUserIds: this.attr([]),
      guestUsers: this.attr([]),
      joinedUserIds: this.attr([]),
      userNotificationId: this.attr(null),
      myMemberId: this.attr(null),
      inDuration: this.boolean(false),
      roomLocked: this.boolean(false)
    }
  }

  static permitAttributes = [
    'meetingTitle',
    'meetingDescription',
    'roomPassword',
    'startAt',
    'endAt',
    'userIds',
    'guestUsers'
  ]

  static skeleton() {
    return Object.fromEntries(
      Object.entries(this.fields())
      .map(([_, object]) => [_, object.value])
      .filter(([key]) => this.permitAttributes.includes(key))
    )
  }

  getOwner() {
    return User.find(this.roomOwnerId)
  }

  getUsers() {
    return User.findIn(this.userIds)
  }

  getVideoRoomMaster() {
    return VideoRoomMaster.query().where('roomId', this.roomId).first()
  }

  invitedByUserId(id) {
    return this.startAt !== null && this.endAt !== null && this.userIds.includes(id)
  }

  isWaitable() {
    if (this.inDuration) return false
    const diffMinutes = moment(this.startAt).diff(moment(new Date), 'minutes')
    return diffMinutes >= 0 && diffMinutes <= 10
  }
}
